import * as actionType from './ActionType';

export const setStep00 = (data) => ({
  type: actionType.SET_VALUE_STEP00,
  payload: data
});
